import { Box, Stack } from "@mui/system";
import { Typography } from "@mui/material";
import { spacing } from "../../../../../../../../../assets/styles/tokens";
import FraudPlayersCard from "./FraudPlayersCard";

// ─── Formatters ──────────────────────────────────────────────────────────────
// Null/undefined metric values are shown as a dash, never zero.
const DASH = "-";

// Plain text/number — dash when missing.
const formatText = (value: any): string =>
  value === null || value === undefined || value === "" ? DASH : String(value);

// Money: rounded, 1000-separated, negative as -$100, positive as $100 (dash when missing).
const formatCurrency = (value: any): string => {
  if (value === null || value === undefined || value === "") return DASH;
  const num = Number(String(value).replace(/[, ]/g, ""));
  if (Number.isNaN(num)) return DASH;
  const formatted = Math.abs(Math.round(num)).toLocaleString("en-US");
  return num < 0 ? `-$${formatted}` : `$${formatted}`;
};

const FraudPlayersItem = ({ data = [] }: { data?: any[] }) => {
  if (!data || data.length === 0) {
    return (
      <Box sx={{ py: 4 }}>
        <Typography textAlign="center" fontSize="14px" color="text.secondary">
          No data found
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
        <Stack spacing={2}>
          {data.map((item: any, index: number) => (
            <FraudPlayersCard
              key={item.brand_id ?? index}
              website_name={formatText(item.brand_display_name)}
              website_id={formatText(item.brand_id)}
              totalIncome={formatCurrency(item.total_income)}
              cpa={formatCurrency(item.cpa)}
              rs={formatCurrency(item.revshare)}
              ftd={formatText(item.ftd)}
              qftd={formatText(item.qftd)}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default FraudPlayersItem;
